import { render, staticRenderFns } from "./PopupIDcard.vue?vue&type=template&id=69cbe207&"
import script from "./PopupIDcard.vue?vue&type=script&lang=js&"
export * from "./PopupIDcard.vue?vue&type=script&lang=js&"
import style0 from "./PopupIDcard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports